import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { makeRequest } from '../../api/api';
import { commonMoodlePayload } from '../../config';
import CryptoJS from 'crypto-js';

export const fetchSkillTestData = createAsyncThunk(
  'skillTestSlice/fetchSkillTestData',
  async (param) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/progress/skill-test-report',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );
      return response.data;
    } catch (e) {}
  }
);

export const fetchAiResponse = createAsyncThunk(
  'skillTestSlice/fetchAiResponse',
  async (param) => {
    const hash = CryptoJS.HmacSHA256(
      JSON.stringify(param.data),
      '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
    ).toString(CryptoJS.enc.Hex);
    try {
      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/progress/generate-report',
        METHODS.POST,
        {},
        { ...param.data },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      if (response.data.success) {
        if (param.type == 'check') {
          response?.data?.data?.default ? param?.cb() : param?.cbAttmempt();
        } else {
          param.cb(response.data.data);
        }
      }
      return response.data;
    } catch (e) {}
  }
);

export const skillTestSlice = createSlice({
  name: 'skillTest',
  initialState: {
    loading: false,
    success: true,
    data: {},

    aiResponse: {},
    aiResponseLoading: false,
    aiResponseSuccess: true
  },
  reducers: {
    resetSkillTestLoadingState: (state) => {
      return {
        loading: true
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSkillTestData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSkillTestData.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data; // Replace state with fetched data
      state.success = action.payload.success;
    });
    builder.addCase(fetchSkillTestData.rejected, (state) => {
      state.loading = false;
    });
    /////////////////////////////////////////////////////////////////////////////////////

    builder.addCase(fetchAiResponse.pending, (state) => {
      state.aiResponseLoading = true;
    });
    builder.addCase(fetchAiResponse.fulfilled, (state, action) => {
      state.aiResponseLoading = false;
      state.aiResponse = action.payload.data;
      state.aiResponseSuccess = action.payload.success;
    });
    builder.addCase(fetchAiResponse.rejected, (state) => {
      state.aiResponseLoading = false;
      state.aiResponseSuccess = action.payload.success;
    });
  }
});

export const { resetSkillTestLoadingState } = skillTestSlice.actions;
export default skillTestSlice.reducer;
